var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h1',[_vm._v(_vm._s(_vm.$t(("views." + (_vm.$options.name.toLowerCase()) + ".title"))))]),_c('KpiDashbaord'),_c('hr')],1)}
var staticRenderFns = []

export { render, staticRenderFns }